export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_CARTS = 'ADD_TO_CARTS'
export const ADD_TO_ORDER = 'ADD_TO_ORDER'
export const CHANGE_REGION = 'CHANGE_REGION'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const RECEIVE_CART = 'RECEIVE_CART'
export const RECEIVE_ORDER = 'RECEIVE_ORDER'
export const CHECKOUT = 'CHECKOUT'
export const ORDER = 'ORDER'
export const REMOVE_CART = 'REMOVE_CART'
export const REMOVE_CART_BY_BATCH = 'REMOVE_CART_BY_BATCH'
export const REMOVE_ORDER = 'REMOVE_ORDER'
export const GET_DATA_FROM_STORAGE = 'GET_DATA_FROM_STORAGE'
export const REQUIRE_LOGIN = 'REQUIRE_LOGIN'
export const BROWSE_PRODUCT = 'BROWSE_PRODUCT'
export const ADD_COMPANY = 'ADD_COMPANY'
export const INIT_COMPANIES = 'INIT_COMPANIES'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const RECEIVE_OPEN_ID = 'RECEIVE_OPEN_ID'
export const RECEIVE_USER = 'RECEIVE_USER'

// product
export const SAVE_PRODUCTS = 'SAVE_PRODUCTS'

// orders
export const SET_UNPAID_COUNT = 'SET_UNPAID_COUNT'
export const SET_UN_REVIEWED_COUNT = 'SET_UNREVIEWED_COUNT'

// order_pay
export const UPDATE_COUPONS = 'UPDATE_COUPONS'
export const TRIGGER_COUPON_ITEM = 'TRIGGER_COUPON_ITEM'
export const UNSELETE_COUPON_ITEM = 'UNSELETE_COUPON_ITEM'
export const UPDATE_CHECK_ITEM = 'UPDATE_CHECK_ITEM'
export const UPDATE_CHECK_COUPONS = 'UPDATE_CHECK_COUPONS'


export const SAVE_BALANCE_INFO = 'SAVE_BALANCE_INFO'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js